/**
 * externalLinks.js - Script som gör så att externa länkar öppnas i ny flik
 * Denna kod körs efter att sidan laddats och hittar alla externa länkar inom artiklar
 * och lägger till target="_blank" och rel="noopener noreferrer" attributen.
 */

document.addEventListener('DOMContentLoaded', function() {
  // Hitta alla länkar inom artikel-innehåll och andra relevanta områden
  const articleLinks = document.querySelectorAll('.c-article__content a, .c-article__picture figcaption a');
  
  articleLinks.forEach(link => {
    const href = link.getAttribute('href');
    
    // Kontrollera om det är en extern länk (börjar med http eller https och inte innehåller vår domän)
    if (href && (href.startsWith('http://') || href.startsWith('https://')) && 
        !href.includes(window.location.hostname)) {
      
      // Lägg till target="_blank" för att öppna i nytt fönster
      link.setAttribute('target', '_blank');
      
      // Lägg till rel="noopener noreferrer" av säkerhetsskäl
      // noopener förhindrar att den nya sidan får åtkomst till window.opener
      // noreferrer förhindrar att den nya sidan får information om referenten
      link.setAttribute('rel', 'noopener noreferrer');
      
      // Lägg till en liten visuell indikator för externa länkar om det inte är en caption-länk
      if (!link.querySelector('h2') && !link.classList.contains('no-external-icon')) {
        // Lägg till en liten extern länk-ikon som CSS
        link.classList.add('external-link');
        
        // Lägg till en tooltip som indikerar att länken öppnas i nytt fönster
        link.setAttribute('title', link.getAttribute('title') || 'Öppnas i nytt fönster');
      }
    }
  });
});
